module.exports = __webpack_public_path__ + "img/gc_country_flag_cy.d05b1096.svg";